import { render, staticRenderFns } from "./SnippetField.vue?vue&type=template&id=5895314a&scoped=true&"
import script from "./SnippetField.vue?vue&type=script&lang=js&"
export * from "./SnippetField.vue?vue&type=script&lang=js&"
import style0 from "./SnippetField.vue?vue&type=style&index=0&id=5895314a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5895314a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
